<template>
  <div id="define">
    <div class="header flex-between">
      <div class="header-text">
        <h1>原因定义管理</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchList"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="createVisible = true"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="iconfont icon-xiugai1"
          @click="handleEdit"
          >修改</el-button
        >
      </div>
    </div>
    <!--创建弹窗  -->
    <div class="create">
      <el-dialog
        width="35%"
        title="原因定义-创建"
        :visible.sync="createVisible"
        :closeOnClickModal="false"
        @close="createVisibleClose"
      >
        <div>
          <el-form
            size="mini"
            label-position="right"
            :rules="rules"
            ref="createFormRef"
            label-width="130px"
            :model="formLabelAlign"
          >
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="原因类型" prop="reasonKind">
                  <el-select
                    style="width: 100%"
                    v-model="formLabelAlign.reasonKind"
                  >
                    <el-option
                      v-for="item in reasonSateOptionsTT"
                      :key="item.reasonkind"
                      :label="item.kinddescCn"
                      :value="item.reasonkind"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="原因中文" prop="reason_CN">
                  <el-input v-model="formLabelAlign.reason_CN"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="原因英文" prop="reason_EN">
                  <el-input v-model="formLabelAlign.reason_EN"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="状态" prop="state">
                  <el-select v-model="formLabelAlign.state" style="width: 100%">
                    <el-option
                      v-for="item in optionsState"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="排序">
                  <el-input
                    v-model="formLabelAlign.sortIndex"
                    type="text"
                    onkeyup="value=value.replace(/[^\d]/g,'')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="">
                  <span style="margin-right: 5px; color: #76734f"
                    >需要额外输入备注</span
                  >
                  <el-checkbox
                    v-model="formLabelAlign.isNeedOtherReason"
                  ></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="是否违规">
                  <el-select
                    style="width: 100%"
                    v-model="formLabelAlign.isForbit"
                  >
                    <el-option
                      v-for="item in optionsViolation"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="saveVisible">保 存</el-button>
          <el-button @click="createVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!--修改弹窗  -->
    <div class="amend">
      <el-dialog
        width="35%"
        title="原因定义-修改"
        :visible.sync="amendVisible"
        :closeOnClickModal="false"
        @close="amendVisibleClose"
      >
        <div>
          <el-form
            size="mini"
            label-position="right"
            :rules="rules"
            ref="modifyFormRef"
            label-width="100px"
            :model="modiForm"
          >
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="原因类型" prop="reasonKind">
                  <el-select style="width: 100%" v-model="modiForm.reasonKind">
                    <el-option
                      v-for="item in reasonSateOptionsTT"
                      :key="item.reasonkind"
                      :label="item.kinddescCn"
                      :value="item.reasonkind"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="原因中文" prop="reason_CN">
                  <el-input v-model="modiForm.reason_CN"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="原因英文" prop="reason_EN">
                  <el-input v-model="modiForm.reason_EN"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="状态">
                  <el-select v-model="modiForm.state" style="width: 100%">
                    <el-option
                      v-for="item in optionsState"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="排序">
                  <el-input
                    v-model="modiForm.sortIndex"
                    type="text"
                    onkeyup="value=value.replace(/[^\d]/g,'')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="" label-width="200">
                  <span style="color: #76734f">需要额外输入备注</span>
                  <el-checkbox
                    v-model="modiForm.isNeedOtherReason"
                  ></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="24">
                <el-form-item label="是否违规">
                  <el-select style="width: 100%" v-model="modiForm.isForbit">
                    <el-option
                      v-for="item in optionsViolation"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modifySave">保 存</el-button>
          <el-button @click="amendVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-card shadow="never">
      <div class="searchform">
        <el-form size="small" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="原因类型">
                <el-select style="width: 100%" v-model="reasonKind">
                  <el-option
                    v-for="item in reasonSateOptions"
                    :key="item.reasonkind"
                    :label="item.kinddescCn"
                    :value="item.reasonkind"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div>
      <el-card shadow="never" class="centercard">
        <el-table
          size="small"
          height="560"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-radio
                style="margin-left: 10px"
                :label="scope.$index"
                v-model="radio"
                @change.native="handleSelectionChange(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column prop="reasonKind" label="原因类型">
            <template slot-scope="scope">
              {{
                scope.row.reasonKind == 100
                  ? "手工级别变更原因"
                  : "预约取消原因"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="reason_CN" label="原因中文"> </el-table-column>
          <el-table-column prop="reason_EN" label="原因英文"> </el-table-column>
          <el-table-column prop="sortIndex" label="排序"> </el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              {{ scope.row.state == 0 ? "有效" : "无效" }}
            </template>
          </el-table-column>
          <el-table-column prop="isForbit" label="是否违规">
            <template slot-scope="scope">
              {{
                scope.row.isForbit == 0
                  ? "待定"
                  : scope.row.isForbit == 1
                  ? "不违规"
                  : "违规"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="isNeedOtherReason" label="需要额外输入备注">
            <template slot-scope="scope">
              {{ scope.row.isNeedOtherReason == true ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
            <template slot-scope="scope">{{
              scope.row.createTime | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column prop="updateUserName" label="最后修改人">
          </el-table-column>
          <el-table-column prop="updateTime" label="最后修改时间">
            <template slot-scope="scope">
              <div v-if="scope.row.updateTime !== null">
                {{ scope.row.updateTime | dateFormat }}
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getcpyNo } from "@/utils/auth";
import {
  queryReasonKindDescApi,
  reasonListApi,
  reasonInsertApi,
  reasonUpdateApi,
} from "@/api/shop";
export default {
  name: "centre",
  data() {
    return {
      radio: "",
      loading: false,
      amendVisible: false,
      createVisible: false,
      labelPosition: "top",

      rules: {
        reasonKind: [
          { required: true, message: "请选择原因类型", trigger: "change" },
        ],
        reason_CN: [
          { required: true, message: "请填写中文内容", trigger: "blur" },
        ],
        reason_EN: [
          { required: true, message: "请填写英文内容", trigger: "blur" },
        ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      reasonSateOptions: [], //原因
      reasonSateOptionsTT: [],
      sel: "",
      formLabelAlign: {
        // isForbit:"",
        // isNeedOtherReason:"",
        // reasonKind:"",
        // reasonID:"",
        // reason_CN:"",
        // reason_EN:"",
        // sortIndex:"",
        // state:""
      },
      modiForm: {
        reasonKind: "",
        reason_CN: "",
        reason_EN: "",
        sortIndex: "",
        isForbit: "",
        state: "",
        isNeedOtherReason: "",
      }, // 修改
      optionsViolation: [
        {
          value: 0,
          label: "待定",
        },
        {
          value: 1,
          label: "不违规",
        },
        {
          value: 2,
          label: "违规",
        },
      ],
      optionsState: [
        {
          value: 0,
          label: "有效",
        },
        {
          value: 1,
          label: "无效",
        },
      ],
      tableData: [],
      changeValue: [],
      reasonKind: "",
      config: {
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
      },
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
      },
    };
  },
  computed: {
    isMore() {
      return this.config.pageNo >= this.config.pagesTotal;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  created() {
    this.reasonList();
    this.reasonListTT();
    this.tableList();
    let Define = JSON.parse(localStorage.getItem("Define"));
    console.log(Define);
    for (let i = 0; i < Define.length; i++) {
      if (Define[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Define[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Define[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }
    }
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.config.pageNo += 1;
        this.tableList();
      }, 500);
    },
    // 原因类型列表
    reasonList() {
      queryReasonKindDescApi().then((res) => {
        if (res.success) {
          this.reasonSateOptionsTT = res.data;
          res.data.unshift({
            kinddescCn: "全部",
            kinddescEn: "全部",
            reasonKind: "",
          });
          this.reasonSateOptions = res.data;
        }
      });
    },
    reasonListTT() {
      queryReasonKindDescApi().then((res) => {
        if (res.success) {
          this.reasonSateOptionsTT = res.data;
        }
      });
    },
    // 搜索
    searchList() {
      this.loading = true;
      this.tableData = [];
      this.config.total = 0;
      this.config.pageNo = 1;
      this.tableList();
    },
    tableList() {
      // 请求参数
      let queryInfo = {
        cpyNO: getcpyNo(),
        pageNo: this.config.pageNo,
        pageSize: this.config.pageSize,
        reasonKind: this.reasonKind,
      };
      reasonListApi(queryInfo).then((res) => {
        if (this.config.pageNo == 1) this.tableData = [];
        this.tableData = this.tableData.concat(res.data.list); //因为每次后端返回的都是数组，所以这边把数组拼接到一起
        this.config.pageSize = res.data.pageSize;
        this.loading = false;
      });
    },
    handleSelectionChange(val) {
      this.changeValue = val;
      // console.log(val)
    },
    //创建
    saveVisible() {
      this.$refs.createFormRef.validate(async (valid) => {
        if (!valid) return;
        let createQuery = {
          // cpyNO: getcpyNo(),
          isForbit: this.formLabelAlign.isForbit,
          isNeedOtherReason: this.formLabelAlign.isNeedOtherReason,
          reasonKind: this.formLabelAlign.reasonKind,
          reasonID: this.formLabelAlign.reasonID,
          reason_CN: this.formLabelAlign.reason_CN,
          reason_EN: this.formLabelAlign.reason_EN,
          sortIndex: this.formLabelAlign.sortIndex,
          state: this.formLabelAlign.state,
        };
        await reasonInsertApi(require("qs").stringify(createQuery)).then(
          (res) => {
            if (res.message == "success") {
              this.createVisible = false;
              this.$message.success("创建成功!");
              this.radio = "";
              this.tableData = [];
              this.config.total = 0;
              this.config.pageNo = 1;
              this.tableList();
            } else {
              this.$message.error(res.message);
            }
            this.formLabelAlign = {};
          }
        );
      });
    },
    // 修改弹窗
    handleEdit() {
      if (this.changeValue.length == 0) {
        return this.$message.info("请选则数据!");
      } else {
        console.log("打开啦");
        this.amendVisible = true;
        this.modify();
      }
    },
    // 点击
    modify() {
      this.modiForm.reasonKind = this.changeValue.reasonKind;
      this.modiForm.reason_CN = this.changeValue.reason_CN;
      this.modiForm.reason_EN = this.changeValue.reason_EN;
      this.modiForm.sortIndex = this.changeValue.sortIndex;
      this.modiForm.isForbit = this.changeValue.isForbit;
      this.modiForm.state = this.changeValue.state;
      this.modiForm.isNeedOtherReason = this.changeValue.isNeedOtherReason;
    },
    // 修改
    modifySave() {
      this.$refs.modifyFormRef.validate((valid) => {
        if (valid) {
          reasonUpdateApi({
            reasonKind: this.modiForm.reasonKind,
            reasonID: this.changeValue.reasonID,
            reason_CN: this.modiForm.reason_CN,
            reason_EN: this.modiForm.reason_EN,
            sortIndex: this.modiForm.sortIndex,
            isForbit: this.modiForm.isForbit,
            state: this.modiForm.state,
            isNeedOtherReason: this.modiForm.isNeedOtherReason,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("修改成功!");
              this.amendVisible = false;
              this.radio = "";
              this.tableData = [];
              this.config.total = 0;
              this.config.pageNo = 1;
              this.tableList();
            } else {
              this.$message.error("修改失败!");
            }
          });
        }
      });
    },
    amendVisibleClose() {
      console.log("清空啦");
      this.$refs.modifyFormRef.resetFields();
    },
    createVisibleClose() {
      this.$refs.createFormRef.resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
#define {
  // height: 1350px;
  height: 100%;
}
.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 20px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 20px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
}
</style>
